import React from 'react';
import classNames from 'classnames';

import checkCircleIcon from '@alumni_v2/images/svg/checkCircle.svg';

import styles from './ACSConnectSuccess.module.scss';

const ACSConnectSuccess = ({
  context = 'thank_you_stage',
}) => {
  const { showExpertAcs } = window.__INITIAL_STATE__;

  return (
    <div className={classNames(styles.container,
      {
        [styles.containerIntermediate]:
            context === 'intermediate_stage',
      })}
    >
      <div className={classNames(styles.successContainer,
        {
          [styles.successContainerIntermediate]:
            context === 'intermediate_stage',
        },
        {
          [styles.successContainerThankYou]:
              context === 'thank_you_stage',
        })}
      >
        <img
          src={checkCircleIcon}
          alt="success check"
          className={styles.checkImage}
        />
        Your request has been registered for an
        {' '}
        {showExpertAcs ? 'Expert' : 'Alumni'}
        {' '}
        Connect Session!
      </div>
      <div className={styles.noteContainer}>
        We’ll get in touch with you within the next 48 Hours.
        Alumni connect depends on to both your profile preferences
        and alumni availability
      </div>
    </div>
  );
};

export default ACSConnectSuccess;
